module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./StoreAgentMsgView.js"));
	}, "StoreAgentMsgView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreAgentMsgView!./src/pages/Store/BusinessManage/StoreAgentMsg/StoreAgentMsgView.js
// module id = 1711
// module chunks = 418